<template>
    <div class="cropper-box">
      <p v-show="imgFile.width" style="margin-bottom: 8px">
        图片原尺寸 {{ imgFile.width }}px * {{ imgFile.height }}px
        <!-- <span v-show="cropBox.width">，裁剪框的尺寸 {{ cropBox.width }}px * {{ cropBox.height }}px</span> -->
      </p>
      <div class="cropper-content">
        <div class="cropper">
          <img style="width:750px;height:750px" ref="image" :src="imgFile.img" />
        </div>
      </div>
      <div class="footer-btn">
        <!-- 缩放旋转按钮 -->
        <div class="scope-btn">
          <a-tooltip placement="bottom">
            <template #title>放大</template>
            <zoom-in-outlined @click="cropperzoom(0.05)" />
          </a-tooltip>
          <a-tooltip placement="bottom">
            <template #title>缩小</template>
            <zoom-out-outlined @click="cropperzoom(-0.05)" />
          </a-tooltip>
          <a-tooltip placement="bottom">
            <template #title>向左转</template>
            <undo-outlined @click="cropperRotate(-90)"/>
          </a-tooltip>
          <a-tooltip placement="bottom">
            <template #title>向右转</template>
            <redo-outlined @click="cropperRotate(90)"/>
          </a-tooltip>
        </div>
        <div class="upload-btn">
          <a-space>
            <a-button
              type="primary"
              @click="sureCrop()"
            >确定裁剪</a-button>
            <a-button
              type="primary"
              @click="cropperReset()"
            >重置</a-button>
            <a-button
              type="primary" danger
              @click="cancelCrop()"
            >关闭窗口</a-button>
          </a-space>
        </div>
      </div>
    </div>  
</template>
<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import { ZoomOutOutlined,ZoomInOutlined, UndoOutlined, RedoOutlined } from '@ant-design/icons-vue'
export default {
  name: 'VueCropper',
  components: {
    ZoomOutOutlined, ZoomInOutlined, UndoOutlined, RedoOutlined
  },
  props: {
    imgFile: Object,
    aspectRatio: {
      type: Number,
      default: 1
    },
    autoCropArea: {
      type: Number,
      default: .98
    }
  },
  data() {
    return {
      myCropper: null,
      cropBox: {}
    } 
  },
  methods: {
    init() {
      // const checkCrossOrigin = this.imgFile.img?.includes('aliyuncs.com') ? false : true
      // console.log(`this.imgFile.img?.includes('aliyuncs.com')`, this.imgFile.img, 'checkCrossOrigin..', checkCrossOrigin)
      // checkCrossOrigin,
        // checkOrientation: false,
      this.myCropper = new Cropper(this.$refs.image, {
        viewMode: 1,
        dragMode: 'move',
        preview: document.querySelector('.before'),
        background: false,
        autoCropArea: this.autoCropArea,
        zoomOnWheel: true,
        aspectRatio: this.aspectRatio,
        cropmove: () => {
          const { width, height } = this.myCropper.getCropBoxData()
          this.cropBox.width = width
          this.cropBox.height = height 
        }
      })
      this.myCropper.replace(this.imgFile.img, false)
    },
    // 点击确定裁剪触发
    async sureCrop() {
      const base64 = this.myCropper
        .getCroppedCanvas({
          imageSmoothingQuality: 'high'
        }).toDataURL('image/jpeg')
      this.$emit('cropper', base64)
    },
    // 点击关闭时出发
    cancelCrop() {
      this.$emit('close')
    },
    // 缩放
    cropperzoom(val) {
      this.myCropper.zoom(val)
    },
    // 左右旋转
    cropperRotate(val) {
      this.myCropper.rotate(val)
    },
    // 重置
    cropperReset() {
      this.myCropper.reset()
    },
    // 移动
    croppermove(val1, val2) {
      this.myCropper.move(val1, val2)
    }
  },
  watch: {
    imgFile() {
      this.init()
      this.cropBox = {}
    }
  },
  mounted() {
    this.init()
  }
}
</script>
<style lang="less" scoped>
  @import './index';
</style>